import Vue from 'vue'
import Auth from './Auth'

export default class Tv {
    constructor() {
        this.baseUrl = "api/tv/";
        this.auth = new Auth();
        this.tv =  [];        
    }
    

    async load() {
        let res = await Vue.axios.get(this.baseUrl + "list",this.auth.getHeader());
        this.tv = await res.data;        
        return this.tv;
    }
    getFilterTv(category)
    {
        return Vue.axios.get(this.baseUrl + "list?category=" + category,this.auth.getHeader());        
    }
    getTv(search_key)
    {
        return Vue.axios.get(this.baseUrl + "get?search_key=" + search_key,this.auth.getHeader());        
    }
    getTvByProvincia(provincia)
    {
        return Vue.axios.get(this.baseUrl + "get-by-provincia?provincia=" + provincia,this.auth.getHeader());        
    }
    setFavorite(search_key, favorite) {        
        return Vue.axios.post(this.baseUrl + "set-favorite", JSON.stringify({ search_key: search_key,favorite: favorite,}),this.auth.getHeader());        
    }
    getFavoriteTv()
    {
        return Vue.axios.get(this.baseUrl + "list-favorite",this.auth.getHeader());        
    }
    getSearchTv(search)
    {
        return Vue.axios.get(this.baseUrl + "search?search=" + search,this.auth.getHeader());        
    }

    getProssimiTg()
    {
        return Vue.axios.get(this.baseUrl + "get-tg",this.auth.getHeader());  
    }

    getTvTerritorio()
    {
        return Vue.axios.get(this.baseUrl + "territorio",this.auth.getHeader());          
    }
}
